var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{class:{ 'condensed-cell': _vm.condensed, 'expandable': _vm.expandable },on:{"click":function($event){return _vm.handleClick($event)}}},[_vm._t("default",null,{"expanded":_vm.expanded})],2)}
var staticRenderFns = []

export { render, staticRenderFns }